import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Sun, Moon, Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";

const navItems = [
        { to: "/", label: "Arquivo", testId: NAV.archiveLink, exact: true },
        { to: "/noticias", label: "Dossiês ao vivo", testId: "nav-news-link" },
        { to: "/admin", label: "Restrito", testId: NAV.adminLink },
];

export const Header = () => {
        const { pathname } = useLocation();
        const [isLight, setIsLight] = useState(() => {
                return localStorage.getItem("theme") === "light";
        });
        const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

        useEffect(() => {
                if (isLight) {
                        document.documentElement.classList.add("light");
                        localStorage.setItem("theme", "light");
                } else {
                        document.documentElement.classList.remove("light");
                        localStorage.setItem("theme", "dark");
                }
        }, [isLight]);

        // Close mobile menu when route changes
        useEffect(() => {
                setIsMobileMenuOpen(false);
        }, [pathname]);

        const toggleTheme = () => setIsLight(!isLight);

        return (
                <>
                        <header className="sticky top-0 z-50 w-full border-b border-[var(--line-strong)] bg-[var(--bg)]/80 backdrop-blur-md">
                                <div className="border-b border-[var(--line)] bg-[var(--ink)]/5">
                                        <div className="mx-auto max-w-[1400px] px-6 lg:px-12 py-1.5 flex items-center justify-between text-[10px] font-mono tracking-[0.3em] uppercase text-[var(--ink-faint)]">
                                                <span>Arquivo · Lisboa · pt-PT</span>
                                                <span className="hidden md:inline pulse-class">
                                                        <span style={{ color: "var(--classified)" }}>●</span>{" "}
                                                        Sessão pública · Sigilo parcial
                                                </span>
                                                <span>v1.2 / 2026</span>
                                        </div>
                                </div>
                                <div className="mx-auto max-w-[1400px] px-4 lg:px-12 py-4 flex items-center justify-between gap-4 md:gap-8">
                                        <Link
                                                to="/"
                                                className="flex items-baseline gap-3 group shrink-0"
                                        >
                                                <span className="font-serif italic font-bold text-2xl md:text-3xl leading-none tracking-tight text-[var(--ink)] group-hover:text-[var(--controversy)] transition-colors">
                                                        Verdade Oculta
                                                </span>
                                                <span className="overline text-[var(--ink-faint)] hidden md:inline self-end mb-1">
                                                        · dossiê PT
                                                </span>
                                        </Link>

                                        {/* Desktop Navigation */}
                                        <nav className="hidden md:flex items-center gap-4 pb-1 -mb-1">
                                                {navItems.map((item) => {
                                                        const active = item.exact
                                                                ? pathname === item.to
                                                                : pathname.startsWith(item.to);
                                                        return (
                                                                <NavLink
                                                                        key={item.to}
                                                                        to={item.to}
                                                                        data-testid={item.testId}
                                                                        className={`overline px-3 py-2 transition-colors ${
                                                                                active
                                                                                        ? "text-[var(--controversy)]"
                                                                                        : "text-[var(--ink-soft)] hover:text-[var(--ink)]"
                                                                        }`}
                                                                >
                                                                        {item.label}
                                                                </NavLink>
                                                        );
                                                })}
                                                <button
                                                        type="button"
                                                        onClick={toggleTheme}
                                                        className="ml-2 p-2 text-[var(--ink-soft)] hover:text-[var(--ink)] transition-colors"
                                                        aria-label="Alternar modo claro/escuro"
                                                >
                                                        {isLight ? <Moon size={16} /> : <Sun size={16} />}
                                                </button>
                                        </nav>

                                        {/* Mobile Toggle Buttons */}
                                        <div className="flex md:hidden items-center gap-2">
                                                <button
                                                        type="button"
                                                        onClick={toggleTheme}
                                                        className="p-2 text-[var(--ink-soft)] hover:text-[var(--ink)] transition-colors"
                                                        aria-label="Alternar modo claro/escuro"
                                                >
                                                        {isLight ? <Moon size={20} /> : <Sun size={20} />}
                                                </button>
                                                <button
                                                        type="button"
                                                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                                                        className="p-2 text-[var(--ink)] hover:text-[var(--controversy)] transition-colors"
                                                        aria-label="Alternar menu"
                                                        aria-expanded={isMobileMenuOpen}
                                                        aria-controls="mobile-navigation"
                                                >
                                                        {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                                                </button>
                                        </div>
                                </div>

                                {/* Mobile Dropdown Menu */}
                                {isMobileMenuOpen && (
                                        <div className="md:hidden border-t border-[var(--line)] bg-[var(--bg)]/95 backdrop-blur-md">
                                                <nav id="mobile-navigation" className="flex flex-col py-4 px-4 gap-2">
                                                        {navItems.map((item) => {
                                                                const active = item.exact
                                                                        ? pathname === item.to
                                                                        : pathname.startsWith(item.to);
                                                                return (
                                                                        <NavLink
                                                                                key={item.to}
                                                                                to={item.to}
                                                                                data-testid={item.testId}
                                                                                className={`overline px-4 py-3 rounded-md transition-colors ${
                                                                                        active
                                                                                                ? "bg-[var(--line)] text-[var(--controversy)]"
                                                                                                : "text-[var(--ink-soft)] hover:bg-[var(--line)] hover:text-[var(--ink)]"
                                                                                }`}
                                                                        >
                                                                                {item.label}
                                                                        </NavLink>
                                                                );
                                                        })}
                                                </nav>
                                        </div>
                                )}
                        </header>
                </>
        );
};

export default Header;
